<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "tool-edit-info-issues",
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

</style>